import React from 'react';
import { PipeStep } from '.';

export const PipeSteps: React.FC = () => (
  <div className="w-full flex md:mt-10 mb-16 justify-center items-center px-4">
    <PipeStep stepNumber={1} stepName="Panier" type="PAST" />
    <span className="h-0.5 bg-navy-blue md:w-[148px] w-[45px]" />
    <PipeStep stepNumber={2} stepName="Identification" type="PRESENT" />
    <span className="h-0.5 bg-light-silver md:w-[148px] w-[45px]" />
    <PipeStep stepNumber={3} stepName="Livraison & paiement" type="FUTUR" />
    <span className="h-0.5 bg-light-silver md:w-[148px] w-[45px]" />
    <PipeStep stepNumber={4} stepName="Confirmation" type="FUTUR" />
  </div>
);
